import { apiClient } from "../Auth/apiClient";
import IPageResultDto from "../Interfaces/IPageResultDto";
import IResponseBaseDto from "../Interfaces/IResponseBaseDto";
import IResponseBaseTDto from "../Interfaces/IResponseBaseTDto";
import ISearchBaseDto from "../Interfaces/ISearchBaseDto";
import { ICorporationBasicDto, ICorporationDetailsDto, AutocompleteDto } from "../Interfaces/ICorporationDtos";

const apiPath = `corporations`;

const CorporationServiceAPI = {
  GetOne: async (id: string): Promise<IResponseBaseTDto<ICorporationDetailsDto>> => {
    const response = await apiClient.get(`${apiPath}/${id}`);
    return response.data;
  },
  GetAll: async (): Promise<IResponseBaseTDto<[AutocompleteDto]>> => {
    const response = await apiClient.get(`corporation/list`);
    return response.data;
  },
  GetPage: async (data: ISearchBaseDto): Promise<IResponseBaseTDto<IPageResultDto<ICorporationBasicDto>>> => {
    const response = await apiClient.post(`${apiPath}/page`, data);
    return response.data;
  },
  Update: async (data: ICorporationDetailsDto): Promise<IResponseBaseDto> => {
    const response = await apiClient.put(`${apiPath}/${data.id}`, data);
    return response.data;
  },
  Add: async (data: ICorporationDetailsDto): Promise<IResponseBaseDto> => {
    const response = await apiClient.post(`${apiPath}`, data);
    return response.data;
  },
  Delete: async (data: string): Promise<IResponseBaseDto> => {
    const response = await apiClient.delete(`${apiPath}/${data}`);
    return response.data;
  }
};

export default CorporationServiceAPI;
